import { SafeUrl } from '@angular/platform-browser';

export interface ImageInfo {
  id?: string;
  url?: string | SafeUrl;
  alt?: string;
  height?: string;
  width?: string;
}
